import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track, init, setUserId } from '../lib/analytics';

// Module-scoped to survive StrictMode's mount-unmount-remount cycle.
let lastTrackedPath: string | undefined;

export function useAnalyticsPageView(userId: string | undefined): void {
  const location = useLocation();

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    setUserId(userId);
  }, [userId]);

  useEffect(() => {
    if (location.pathname !== lastTrackedPath) {
      const referrer = lastTrackedPath ?? '';
      lastTrackedPath = location.pathname;
      track('page_view', {
        path: location.pathname,
        referrer,
      });
    }
  }, [location.pathname]);
}
